var _rect, _path, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlanCardLoadingMob = function SvgPlanCardLoadingMob(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 204,
    viewBox: "0 0 272 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 272,
    height: 204,
    rx: 2.72697,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.72697C0 1.22091 1.22091 0 2.72697 0H269.273C270.779 0 272 1.22091 272 2.72697V124H0V2.72697Z",
    fill: "#F3F3F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 140,
    width: 240,
    height: 48,
    rx: 2.72697,
    fill: "#F3F3F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 54,
    width: 240,
    height: 48,
    rx: 2.72697,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 64,
    height: 16,
    rx: 2.72697,
    fill: "#D9D9D9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlanCardLoadingMob);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjcyIiBoZWlnaHQ9IjIwNCIgdmlld0JveD0iMCAwIDI3MiAyMDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHk9IjAuMDAwOTc2NTYyIiB3aWR0aD0iMjcyIiBoZWlnaHQ9IjIwNCIgcng9IjIuNzI2OTciIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0wIDIuNzI2OTdDMCAxLjIyMDkxIDEuMjIwOTEgMCAyLjcyNjk3IDBIMjY5LjI3M0MyNzAuNzc5IDAgMjcyIDEuMjIwOTEgMjcyIDIuNzI2OTdWMTI0SDBWMi43MjY5N1oiIGZpbGw9IiNGM0YzRjQiLz4KPHJlY3QgeD0iMTYiIHk9IjE0MCIgd2lkdGg9IjI0MCIgaGVpZ2h0PSI0OCIgcng9IjIuNzI2OTciIGZpbGw9IiNGM0YzRjQiLz4KPHJlY3QgeD0iMTYiIHk9IjU0IiB3aWR0aD0iMjQwIiBoZWlnaHQ9IjQ4IiByeD0iMi43MjY5NyIgZmlsbD0iI0Q5RDlEOSIvPgo8cmVjdCB4PSIxNiIgeT0iMTYiIHdpZHRoPSI2NCIgaGVpZ2h0PSIxNiIgcng9IjIuNzI2OTciIGZpbGw9IiNEOUQ5RDkiLz4KPC9zdmc+Cg==";